import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, NavItem} from 'react-bootstrap';
//import { LinkContainer } from 'react-router-bootstrap';

import logo from '../../../assets/img/NZFCDlogo.png';
import stacked_logo from '../../../assets/img/NZFCD_search_header_stacked.png'


import './Navigation.css';

class Navigation extends Component {
  render() {
    return(
      <Navbar fluid collapseOnSelect>
        <div className="constrainer">
          <div className="container">
            <Navbar.Header>
              <Navbar.Brand>
                <a href="/">
                  <img id = 'rowlogo' src={ logo } alt="New Zealand Food Composition Database" />
                   <img id = 'stackedlogo' src={ stacked_logo } alt="New Zealand Food Composition Database" />
              </a>
              </Navbar.Brand>
            </Navbar.Header>
            <Navbar.Collapse>
              <ul className='navbar-nav'>

                <NavItem href="/">HOME</NavItem>
                <NavItem active={true} href="/search" >SEARCH</NavItem>

                <NavItem href="/foodfiles">DOWNLOADS</NavItem>
                <NavItem href="/about">ABOUT</NavItem>
                <NavItem href="/frequently-asked-questions">FAQ</NavItem>
                <NavItem href="/glossary">GLOSSARY</NavItem>
                <NavItem href="/useful-links">USEFUL LINKS</NavItem>
            </ul>

            </Navbar.Collapse>
            <Navbar.Toggle />
          </div>

        </div>

      </Navbar>


    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/presentation/Navigation/Navigation.js